import { MaterialDesignContent } from 'notistack'
import styled from 'styled-components'

const CustomSnackbar = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#E2F5E8',
    color: '#424A52',
  },
}))

export default CustomSnackbar
